module.exports = __webpack_public_path__ + "img/Wp_2090.fba32319.png";